import { Author, Caption, LayoutConfig, PageConfig, TextConfig, UserConfig } from './src/config/models';

// Texte für Title, SEO & Sharing, ...
const de: TextConfig = {
    title: 'Merkel nach Zahlen: Zeichnen Sie selbst!',
    headline: 'Merkel nach Zahlen',
    description:
        'Staatsverschuldung, Asylanträge, Windkraft: Wie hat sich Deutsch­land unter Angela Merkels Kanzlerschaft verändert? Zeichnen Sie das Diagramm und schätzen Sie die Werte.',
    mobileShareText: 'Zeichnen Sie selbst: Wie hat sich Deutsch­land unter Angela Merkel verändert?',
    twitterShareText: 'Zeichnen Sie selbst: Wie hat sich Deutsch­land unter Angela Merkel verändert?',
    whatsappShareText: 'Zeichnen Sie selbst: Wie hat sich Deutsch­land unter Angela Merkel verändert?',
    mailShareText: 'Zeichnen Sie selbst: Wie hat sich Deutsch­land unter Angela Merkel verändert?'
};

// Falls englische Seite gewünscht ("provideEn" in pageConfig = true), Übersetzungen hier eintragen:
const en: TextConfig = {
    title: 'Longread Template',
    headline: 'This is the headline of the longread template',
    description: 'Written in react and typescript',
    mobileShareText: 'Special share text for mobile sharing'
};

// Konfiguration der Seiteninhalte
const pageConfig: Omit<PageConfig, 'url'> = {
    authors: [Author.SteffenKuehne, Author.LudwigSpitaler, Author.LinusLuering],
    keywords: ['Angela Merkel', 'Quiz', 'Bundestagswahl'],
    caption: Caption.Deutschland,
    ATId: 'merkel-nach-zahlen',
    provideEn: false,
    previewImage: 'media/teaser.jpg',
    headerImage: 'media/header.jpg'
};

// Basic Layout Konfiguration
const layoutConfig: LayoutConfig = {
    showAside: true,
    showProgress: true,
    headerOverlay: true
};

// Hier nichts verändern
export const config: UserConfig = {
    ...pageConfig,
    ...layoutConfig,
    de,
    en
};
